import AppStore from '~publish/legacy/composer/composer/stores/AppStore'
import type { ComposerProfile } from '~publish/legacy/composer/composer/stores/types'

type UseSelectedProfilesReturn = {
  isOmniboxEnabled: boolean | null
  selectedProfiles: ComposerProfile[]
  hasMultipleProfilesEnabled: boolean
  isApprovalRequired: boolean
  isSaveAndRequestApprovalDisabled: boolean
  doSelectedProfilesHaveSlots: boolean
}

export const useSelectedProfiles = (): UseSelectedProfilesReturn => {
  const isOmniboxEnabled = AppStore.getIsOmniboxEnabled()
  const selectedProfiles = AppStore.getSelectedProfiles()
  const hasMultipleProfilesEnabled = selectedProfiles.length > 1
  const approvalRequiredFor = AppStore.requiresApprovalForSelectedProfiles()

  const doSelectedProfilesHaveSlots =
    selectedProfiles.length === 0 ||
    selectedProfiles.some(
      (profile): boolean => profile.profileHasPostingSchedule,
    )

  return {
    isOmniboxEnabled,
    selectedProfiles,
    hasMultipleProfilesEnabled,
    isApprovalRequired: approvalRequiredFor !== 'none',
    isSaveAndRequestApprovalDisabled: approvalRequiredFor !== 'all',
    doSelectedProfilesHaveSlots,
  }
}
